import { TextNode } from 'lexical';
// RichTextPlugin lets the input preserve decoration nodes, but it can also import
// text formatting from pasted HTML. Keep the ResizableInput visually plain.
export const textNodeTransform = ({ editor, }) => editor.registerNodeTransform(TextNode, (textNode) => {
    if (textNode.getFormat() !== 0) {
        textNode.setFormat(0);
    }
});
//# sourceMappingURL=textNodeTransform.js.map